import React, { useState } from "react";
import { X } from "lucide-react";
import { IconButton, Input } from "../ui";
import { LIMITS } from "./syllabusModel";

/**
 * A topic's subtopics as chips, with one field to add more: Enter adds what is
 * typed, and a pasted list (one per line, or comma-separated) becomes several.
 *
 * Props: subtopics (string[]), onChange(next), topicTitle (for names)
 */
const SubtopicsEditor = ({ subtopics = [], onChange, topicTitle }) => {
  const [draft, setDraft] = useState("");

  const add = (values) => {
    const clean = values.map((v) => v.trim().slice(0, LIMITS.subtopic)).filter(Boolean);
    if (!clean.length) return;
    onChange([...subtopics, ...clean]);
    setDraft("");
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      add([draft]);
    } else if (e.key === "Backspace" && !draft && subtopics.length) {
      onChange(subtopics.slice(0, -1));
    }
  };

  const onPaste = (e) => {
    const pasted = e.clipboardData?.getData("text") || "";
    if (!/[\n,]/.test(pasted)) return;
    e.preventDefault();
    add(pasted.split(/[\n,]/));
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      {subtopics.length > 0 && (
        <ul className="tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-gap-1.5 tw-p-0" aria-label={`Subtopics of ${topicTitle || "this topic"}`}>
          {subtopics.map((s, i) => (
            <li key={`${s}-${i}`} className="tw-inline-flex tw-items-center tw-gap-0.5 tw-rounded-full tw-border tw-border-solid tw-border-line tw-bg-surface-sunken tw-py-0.5 tw-pe-0.5 tw-ps-2.5 tw-text-xs tw-text-content">
              {s}
              <IconButton size="xs" icon={X} label={`Remove subtopic ${s}`} onClick={() => onChange(subtopics.filter((_, j) => j !== i))} />
            </li>
          ))}
        </ul>
      )}
      <Input
        size="sm"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        onBlur={() => add([draft])}
        placeholder="Add a subtopic and press Enter"
        aria-label={`Add a subtopic to ${topicTitle || "this topic"}`}
      />
    </div>
  );
};

export default SubtopicsEditor;
